import { AdminTemplateForm } from './AdminTemplateForm';

export default AdminTemplateForm;